import { c as _c } from "react/compiler-runtime";
import { DefinitionList, DetailSection } from "@/shared/ui";
import type { Profile } from "@/features/auth/api/types";
type MonthlyTargetsSectionProps = Readonly<{
  profile: Profile;
  isLoading: boolean;
}>;
export function MonthlyTargetsSection(t0) {
  const $ = _c(10);
  const {
    profile,
    isLoading
  } = t0;
  const hasTargets = profile.accountType === "STREAMER" && (profile.contract?.airtime !== 0 || profile.contract?.shareOfViewership !== 0);
  if (!isLoading && !hasTargets) {
    return null;
  }
  const t1 = profile.contract?.airtime != null ? `${profile.contract.airtime} hours` : "\u2014";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      label: "Airtime",
      value: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = profile.contract?.shareOfViewership != null ? `${profile.contract.shareOfViewership}%` : "\u2014";
  let t4;
  if ($[2] !== t3) {
    t4 = {
      label: "Share of Airtime",
      value: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = [t2, t4];
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isLoading || $[8] !== t5) {
    t6 = <DetailSection label="MONTHLY TARGETS"><DefinitionList isLoading={isLoading} loadingRows={2} items={t5} /></DetailSection>;
    $[7] = isLoading;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}